import React, { Component } from 'react';
import * as axios from 'axios';
import contactImage from '../../assets/img/android-1869510_640.jpg';
import './contact.scss';

export interface IEmailMessage {
    email?: string;
    contact?: string;
    message?: string;
    show?: boolean;
}
export default class Contact extends Component<{}, IEmailMessage> {
    constructor(props: Readonly<{}>) {
        super(props);

        this.state = {
            email: '',
            contact: '',
            message: '',
            show: false
        };
        this.changeHandler = this.changeHandler.bind(this);
        this.submitForm = this.submitForm.bind(this);
    }

    changeHandler(event: any) {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    async submitForm(event: any) {
        try {
            event.preventDefault();
            const data = {
                contact: this.state.contact,
                message: this.state.message,
                email: this.state.email
            };

            // https://us-central1-decadetrucking.cloudfunctions.net/emailToOperations

            if (data.contact.trim() != '' || data.message.trim() != '') {
                await axios.default.post(
                    'https://us-central1-decadetrucking.cloudfunctions.net/emailToOperations',
                    data,
                    {
                        headers: {
                            'Content-Type': 'application/json;charset=UTF-8',
                            'Access-Control-Allow-Origin': '*'
                        }
                    }
                );
            }

            this.setState({
                email: '',
                contact: '',
                message: '',
                show: true
            });
        } catch (error) {
            console.log(error);
        }
    }

    render() {
        return (
            <div className='row contact'>
                <div className='col'>
                    <div className='row w-100'>
                        <div className='col-md-12 m-2 text-center'>
                            <span className='contact-main'>Contact Us</span>
                            <hr className='w-75 bg-danger' />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-6'>
                            <div className='row contact-margin-top'>
                                <span className='text-center w-100'>Office Address</span>
                                <span className='text-center w-100'>520 Bosworth Street</span>
                                <span className='text-center w-100'>Alrode South</span>
                                <span className='text-center w-100'>1451</span>
                            </div>
                            <div className='row contact-margin-top'>
                                <span className='text-center w-100'>Contact Details</span>
                                <span className='text-center w-100'>Tel : 0116137544</span>
                                <span className='text-center w-100'>Cell : 0826220409</span>
                                <span className='text-center w-100'>Email : operations@decadetrucking.co.za</span>
                            </div>
                        </div>
                        <div className='col-md-6 mb-3 d-flex justify-content-center'>
                            {/* <div className='row '> */}
                            <img src={contactImage} className='contact-img' />
                            {/* <form className='col w-75'>
                                    <div className='form-group'>
                                        <label htmlFor='EmailInput'>Email address</label>
                                        <input
                                            type='email'
                                            className='form-control form-control-lg'
                                            id='email'
                                            name='email'
                                            value={this.state.email}
                                            onChange={this.changeHandler}
                                            aria-describedby='emailAddress'
                                        />
                                    </div>
                                    <div className='form-group'>
                                        <label htmlFor='ContactNumberInput'>Contact number</label>
                                        <input
                                            type='tel'
                                            name='contact'
                                            value={this.state.contact}
                                            onChange={this.changeHandler}
                                            className='form-control form-control-lg'
                                            id='contact'
                                            aria-describedby='ContactNumber'
                                        />
                                    </div>
                                    <div className='form-group'>
                                        <label htmlFor='message'>Message</label>
                                        <textarea
                                            className='form-control form-control-lg'
                                            name='message'
                                            value={this.state.message}
                                            onChange={this.changeHandler}
                                            id='message'
                                        />
                                    </div>
                                    <div className='form-group'>
                                        {this.state.show ? (
                                            <label htmlFor='message'>
                                                Thank you for contacting us. Decade trucking will contact you soon
                                            </label>
                                        ) : null}
                                    </div>
                                    <div className=''>
                                        <button
                                            onClick={this.submitForm}
                                            className='btn btn-lg hvr-shutter-out-horizontal btn-outline-danger'
                                        >
                                            Send
                                        </button>
                                    </div>
                                </form> */}
                        </div>
                        {/* </div> */}
                    </div>
                </div>
            </div>
        );
    }
}
